import { render, staticRenderFns } from "./DispatchReportsTable.vue?vue&type=template&id=631fb76f&scoped=true"
import script from "./DispatchReportsTable.vue?vue&type=script&lang=js"
export * from "./DispatchReportsTable.vue?vue&type=script&lang=js"
import style0 from "./DispatchReportsTable.vue?vue&type=style&index=0&id=631fb76f&prod&scoped=true&lang=scss"
import style1 from "./DispatchReportsTable.vue?vue&type=style&index=1&id=631fb76f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631fb76f",
  null
  
)

export default component.exports